import Excel from "@/views/excel/excel"

export default {
    path: '/Excel',
    name: 'Excel',
    component: Excel,
  }


// WEBPACK FOOTER //
// ./src/router/excel/index.js